import { Component, Input } from '@angular/core';
import { NecLeftNav } from './left-nav';
import { Router } from '@angular/router';

@Component({
  selector: 'left-nav',
  templateUrl: './left-nav.component.html',
  styleUrls: ['./left-nav.component.scss']
})
export class NecLeftNavComponent {
  @Input() navs: NecLeftNav[];

  constructor(private router: Router) {
  }

  goToLink(link: string) {
    this.router.navigate([link]);
  }

}
